import Header from "../Header";
import Footer from "../Footer";
import Breadcrumbs from "../Breadcrumbs";
import BannerImg from "../assets/Images/banner1-1920x450.jpg";
import BottomLogoImg from "../assets/Images/bottom-logo.png";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import "./ContactUsPage.scss";

const ContactUsPage = () => {
  const { t } = useTranslation();

  return (
    <>
      <Header />
      <div className="banner">
        <img src={BannerImg} alt="" />
        <div className="banner_title res">
          <h1 className="banner-main-title">{t("contact_us_page_heading")}</h1>
          <p className="banner-subtitle">{t("contact_us_page_heading2")}</p>
        </div>
      </div>
      <Breadcrumbs>
        <Link>{t("breadcrumbs_contact_us_page_link1")}</Link>
        <span>{t("breadcrumbs_contact_us_page_span")}</span>
        <Link>{t("breadcrumbs_contact_us_page_link2")}</Link>
      </Breadcrumbs>
      <main className="main-section contact-us-page">
        <section className="address-container-contactus">
          <div className="text">
            <h2 className="contact-title">{t("contact_us_page_h3")}</h2>
            <div className="contact-section">
              <p className="contact-info">{t("contact_us_page_text1")}</p>
              <p className="contact-info">{t("contact_us_page_text2")}</p>
              <p className="contact-info">{t("contact_us_page_text3")}</p>
              <p className="contact-info">{t("contact_us_page_text4")}</p>
            </div>
            <div className="contact-section">
              <p className="contact-info">{t("contact_us_page_text5")}</p>
              <p className="contact-info">{t("contact_us_page_text6")}</p>
              <p className="contact-info">{t("contact_us_page_text7")}</p>
            </div>
            <div className="contact-section">
              <p className="contact-info">{t("contact_us_page_text8")}</p>
              <p className="contact-info">{t("contact_us_page_text9")}</p>
              <p className="contact-info">{t("contact_us_page_text10")}</p>
            </div>
          </div>
          <div className="map">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d7383.493645287043!2d114.14971397351074!3d22.287578348878636!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3404007db1bd3359%3A0xeb72c97b40ec5559!2sAlliance%20Building!5e0!3m2!1sen!2shk!4v1668462431021!5m2!1sen!2shk"
              width="600"
              height="450"
              frameBorder="0"
              style={{ border: 0 }}
              allowFullScreen="true"
              aria-hidden="false"
              tabIndex="0"
              title="HKAS Location Map"
            />
          </div>
        </section>
        <section className="temporary">
          <img src={BottomLogoImg} alt="" />
        </section>
      </main>
      <Footer />
    </>
  );
};

export default ContactUsPage;
